// english

export default {
  issue: '问题',
  // tab
  issue_tab_open: '打开的问题',
  issue_tab_closed: '关闭的问题',
  issue_tab_all: '所有问题',

  // status
  issue_status_open: '打开中',
  issue_status_pending: '处理中',
  issue_status_closed: '已关闭',
  issue_status_reopen: '重新打开中',

  // btn
  issue_btn_add: '添加问题',
  issue_btn_share_link: '分享链接',
  issue_btn_reopen: '重新打开问题',
  issue_btn_close: '关闭问题',

  // base
  issue_base_type: '类型',
  issue_base_priority: '优先级',
  issue_base_process: '进度',
  issue_base_device: '关联设备',
  issue_base_first_occurence: '第一次发生时间',

  // 类型 , 问题类型(写死，value值一对一不要改，改了已存在的问题，它的类型就会乱了)
  issue_type_list: [
    {
      value: 1,
      name: '桩的问题',
    },
    {
      value: 2,
      name: '软件Bug',
    },
    {
      value: 3,
      name: '硬件缺陷',
    },
    {
      value: 4,
      name: '设备独立问题',
    },

    {
      value: 5,
      name: '其他',
    },
  ],

  // 问题紧急程序
  issue_urgent_list: [
    {
      value: 0,
      name: 'OA',
    },
    {
      value: 1,
      name: 'MA',
    },
    {
      value: 2,
      name: 'CA',
    },
  ],

  // conifrm
  issue_confirm_close_title: '确定关闭问题?',
  issue_confirm_content: '标题: {title}',
  issue_confirm_reopen_title: '确定重新打开该问题?',
  issue_confirm_delete_title: '确定删除该问题?',
  issue_confirm_delete_comment_title: '确定删除此条评论?',

  // 匿名
  issue_anonymous: '匿名',
  issue_anonymous_new: '添加匿名问题',
  issue_anonymous_share: '分享匿名问题',
  issue_anonymous_share_url: 'URL',
  issue_anonymous_share_password: '密码',
  issue_anonymous_share_copy_info: '复制信息',
  issue_anonymous_share_copy_password: '复制密码',
  issue_anonymous_share_copy_url: ' 复制 URL',
  issue_anonymous_add: '添加匿名问题链接',
  issue_anonymous_add_success: '成功添加匿名问题',
  issue_anonymous_add_fail: '添加匿名问题失败',
  issue_anonymous_edit_success: '编辑问题成功',
  issue_anonymous_edit_fail: '编辑问题失败',

  // append
  issue_append_add: '添加新的描述',
  issue_append_edit: '编辑描述',

  // comment
  issue_comment: '评论',
  issue_comment_add: '添加评论',
  issue_comment_edit: '编辑评论',
  issue_comment_contact: '联系',
  issue_comment_no_empty: '评论内容不能为空',

  // device
  issue_device_select: '选择设备',

  // form
  issue_form_title: '标题',
  issue_form_title_placeholder: '请输入标题',
  issue_form_category: '问题类型',
  issue_form_category_placeholder: '请选择一个问题类型',
  issue_form_priority: '紧急程度',
  issue_form_priority_placeholder: '请选择问题的紧急程度',
  issue_form_occurrence_time: '发生时间',
  issue_form_occurrence_time_placeholder: '请选择问题发生时间',
  issue_form_device: '关联设备',
  issue_form_device_placeholder: '请选择设备',
  issue_form_device_select: '选择设备',
  issue_form_device_soft_version: '设备软件版本',
  issue_form_device_soft_version_placeholder: '请输入设备的软件版本',
  issue_form_site: '关联站点',
  issue_form_site_all: '所有站点',
  issue_form_site_placeholder: '请选择一个站点',
  issue_form_customer: '客户',
  issue_form_device2: '设备',
  issue_form_device2_all: '所有设备',
  issue_form_type: '问题类型',
  issue_form_type_placeholder: '请选择一个问题类型',
};
